import React, { createContext, useState } from "react";

export const SearchIndicatorContext = createContext({});

export const initialSearchValues = {
  name: "",
  departmentId: "",
  divisionId: "",
  monthOfBudget: "",
  yearOfBudget: "",
};

export const initialPageValues = {
  page: 0,
  pageSize: 10,
  // total: 0,
  // totalPage: 0,
  // sortBy: "departmentId",
  // sortDirection: "ASC",
};

const SearchIndicatorProvider = ({ children }) => {
  const [searchValues, setSearchValues] = useState(initialSearchValues);
  const [pageValues, setPageValues] = useState(initialPageValues);
  const [search, setSearch] = useState(true);

  return (
    <SearchIndicatorContext.Provider
      value={{
        searchValues,
        setSearchValues,
        pageValues,
        setPageValues,
        search,
        setSearch,
      }}
    >
      {children}
    </SearchIndicatorContext.Provider>
  );
};

export default SearchIndicatorProvider;
